import { Navigate } from "react-router-dom"

/**
 * Comprueba si el usuario está logeado
 * @returns Redirecciona al login si no está logeado y si lo está renderiza la vista pedida
 */
const PrivateCandidateRouter = ({children}) => {
    const jwt = require("jsonwebtoken");
    const token = sessionStorage.getItem('jwt')
    if (token && token!=='undefined'){
        let token_decode
        try {
            token_decode = jwt.decode(token, { header: true })
        } catch (error) {
            console.error("Error decoding token:", error)
            return <Navigate to="/"/>
        }
        if(token_decode.rol === 'Candidate'){
            return children
        }else{
            return <Navigate to="/"/>
        }
    }else{
        return <Navigate to="/"/>
    }
    
}

export default PrivateCandidateRouter;